<div class="info-view stills-view">
  <div class="info-view-header">
    <div class="info-view-heading">
      <div class="info-view-title">Stills specifications</div>
      @if (canWrite) {
        <button
          mat-mini-fab
          color="buttonSuccess"
          class="info-view-create-button"
          matTooltip="Create stills specification"
          aria-label="Create stills specification"
          (click)="onCreateStills()"
        >
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (loaded) {
    @if (stillsSpecs.length === 0) {
      <div class="empty-state">
        No stills specifications yet. Click Create to add one.
      </div>
    } @else {
      <div class="spec-list">
        @for (row of stillsSpecs; track row.id) {
          <div class="spec-list-item">
            <div class="spec-info">
              <div class="spec-name-row">
                <span class="spec-name">{{ row.name }}</span>
                <span class="range-meta">
                  <mat-icon class="mat-icon-inline">{{ metaBadge(row).icon }}</mat-icon>
                  {{ metaBadge(row).label }}
                </span>
              </div>
              <div class="spec-summary-row">
                <span class="spec-kv"><span class="k">Format</span><span class="v">{{ formatLabel(row) }}</span></span>
                <span class="spec-kv"><span class="k">DPI</span><span class="v">{{ dpiLabel(row) }}</span></span>
                <span class="spec-kv"><span class="k">Size</span><span class="v">{{ sizeLabel(row) }}</span></span>
                @if (qualityLabel(row); as q) {
                  <span class="spec-kv"><span class="k">Quality</span><span class="v">{{ q }}</span></span>
                }
                <span class="spec-kv"><span class="k">Profile</span><span class="v">{{ profileLabel(row) }}</span></span>
              </div>
            </div>
            <div class="row-actions">
              @if (canAudit) {
                <button
                  mat-icon-button
                  color="primary"
                  matTooltip="View change history"
                  aria-label="View change history"
                  (click)="onViewStillsHistory(row)"
                >
                  <mat-icon>history</mat-icon>
                </button>
              }
              @if (canWrite) {
                <button
                  mat-icon-button
                  color="buttonSuccess"
                  matTooltip="Update"
                  aria-label="Update stills specification"
                  (click)="onUpdateStills(row)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Delete"
                  aria-label="Delete stills specification"
                  (click)="onDeleteStills(row)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  }
</div>
